// extracted by mini-css-extract-plugin
module.exports = {"assignTeam":"addKVMSelectionProcess_assignTeam__3j8-k","teamMember":"addKVMSelectionProcess_teamMember__3fVBu","connectionItem":"addKVMSelectionProcess_connectionItem__1rlft"};